export default __webpack_public_path__ + "static/media/1676.4c5d861c.png";